import {DocumentBase, EquipmentForScheduleABillingBrands} from '.';
import {ViewBase} from './ViewBase';
import {defaultViewSelector, ViewSelector} from './ViewSelector';

export type ScheduleAFeeRiskModelWithoutLabels = {
  accountOnFile: number;
  amexBINSponsorPercent: number;
  amexBINTransaction: number;
  annualFee: number;
  annualPCI: number;
  annualPCIWithBreachInsurance: number;
  avsElectronic: number;
  avsVoice: number;
  batch: number;
  chargeBack: number;
  debitAccess: number;
  dejavooEquipmentMonthlyFee?: number;
  dejavooEquipmentMonthlyFeeAdditionalTerminals?: number;
  gatewayMonthly: number;
  gatewaySetup: number;
  gatewayTransaction: number;
  irsRegulatoryFee: number;
  merchantClub: number;
  merchantOnlineAccess: number;
  monthlyMinimum: number;
  monthlyMonitoring: number;
  monthlyProcessingVolumePercent: number;
  otherGateway: number;
  otherTransaction: number;
  pinDebitEBT: number;
  retrieval: number;
  pinDebitSponsorPercent: number;
  valorEquipmentMonthlyFee?: number;
  valorEquipmentMonthlyFeeAdditionalTerminals?: number;
  visaMCDiscBINSponsorPercent: number;
  visaMCDiscBINTransaction: number;
  wirelessTerminalMonthly: number;
  wirelessTransaction: number;
};

export type ScheduleAFeeRiskModel = ScheduleAFeeRiskModelWithoutLabels & {
  /**
   * Labels
   */
  monthlyProcessingVolumePercentLabel?: number | null;
};

export type ScheduleAEquipmentModel = {
  id: string;
  name: string;
};

export type ScheduleA = DocumentBase & ScheduleABase;
export enum SplitMethodType {
  direct = 'direct',
  splitOfSplit = 'splitOfSplit',
}

export const DirectSplitMethodName = 'Direct Schedule A Calculation';

export const DefaultSplitMethodType = SplitMethodType.splitOfSplit;

export type EquipmentModelsForBillingType = {
  [key in EquipmentForScheduleABillingBrands]: ScheduleAEquipmentModel[];
};

export type ScheduleABase = {
  version: number;
  splitMethod: SplitMethodType | undefined;
  splitNegativeResiduals?: boolean;
  riskModels: {
    low: ScheduleAFeeRiskModel;
    medium: ScheduleAFeeRiskModel;
    high: ScheduleAFeeRiskModel;
  };
  equipmentModelsForBilling?: EquipmentModelsForBillingType;
  /**
   * If this schedule A is a copy from another agent's schedule A, this field will contain the ID of that agent
   */
  copiedFromAgentId?: string;
  /**
   * If this schedule A is a copy from group or master agent's schedule A, this field will be true
   */
  copiedFromGroupOrMasterAgent?: boolean;
};

export type ScheduleAView = ViewBase<ScheduleA>;

export const selectScheduleAView: ViewSelector<ScheduleAView, ScheduleA> = snapshot => {
  const scheduleA: ScheduleAView = {
    ...defaultViewSelector(snapshot),
  };
  return scheduleA;
};
